import { useQuery } from '@tanstack/react-query';
import { Subscription } from '$/models/Subscription';
import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';
import { filtersToStringArray } from '@/utils/filtersToStringArray.ts';
import subscriptionRepository from '@/api/repositories/subscriptionRepository/SubscriptionRepository.ts';

const useSubscriptions = (enabled: boolean = true, filters: Filters<Subscription> | undefined = undefined) => {
  const queryKey = ['subscriptions', ...filtersToStringArray(filters)];

  const queryFn = async () => {
    return getSubscriptions(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useSubscriptions;

async function getSubscriptions(filters?: Filters<Subscription>): Promise<Subscription[]> {
  const { data, error } = filters
    ? await subscriptionRepository.findMany(filters, {
        order: {
          by: 'current_period_end',
          ascending: true,
        },
      })
    : await subscriptionRepository.all({
        order: {
          by: 'current_period_end',
          ascending: true,
        },
      });

  if (error) throw new Error(error.message);

  return data ?? [];
}
